import defineComponent from 'flight';

function SiteHeaderNotificationsUI() {
    this.defaultAttrs({
        notificationCountDataAttribute: 'side-menu-notifications-count'
    });

    this._update = function (evt, payload) {

        let previousCount = parseInt(payload.previousCount, 10) || 0;
        let newCount = parseInt(payload.newCount, 10) || 0;

        if (newCount > previousCount) {
            this._increment(newCount - previousCount);
        } else {
            this._decrease(previousCount - newCount);
        }
    };

    this._increment = function (count) {
        this._refresh(this._getCurrentCount() + count);
    };

    this._decrease = function (count) {
        this._refresh(this._getCurrentCount() - count);
    };

    this._refresh = function (count) {
        count = count < 0 ? 0 : count;
        this.$node.data(this.attr.notificationCountDataAttribute, count);
        this.$node.text(count === 0 ? '' : count);
    };

    this._getCurrentCount = function () {
        return parseInt(this.$node.data(this.attr.notificationCountDataAttribute), 10) || 0;
    };

    this.after('initialize', function () {
        this._refresh(0);
        this.on(document, 'ui:site-header-notifications:update', this._update);
    });
}

export default defineComponent.component(SiteHeaderNotificationsUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/site-header-notifications-ui.js